(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('httpUtility', httpUtility);

	function httpUtility(_) {
		function getErrorReason(response) {
			if (response && _.isNumber(response.status)) {
				if (response.status <= 0)
					return 'abort';
				if (response.status === 404)
					return 'notfound';
			}
			return 'error';
		}

		return {
			getErrorReason: getErrorReason
		};
	}
	httpUtility.$inject = ['_'];
})();